import { ThemeEvents } from "@theme/events";

class ProductModelAttributes extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateModel,
    );
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateModel,
    );
  }

  /**
   * @param {import("@theme/events").VariantUpdateEvent} event
   */
  updateModel = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const blockId = this.dataset.blockId;
    if (!blockId) return;

    const selector =
      `product-model-attributes[data-product-id="${this.dataset.productId}"]` +
      `[data-block-id="${blockId}"]`;
    const nextModel = event.detail.data.html.querySelector(selector);
    if (!(nextModel instanceof HTMLElement)) return;
    if (nextModel.innerHTML === this.innerHTML) return;

    this.innerHTML = nextModel.innerHTML;
  };
}

if (!customElements.get("product-model-attributes")) {
  customElements.define("product-model-attributes", ProductModelAttributes);
}
